import { render, staticRenderFns } from "./SystemNotificationManagementSettings.vue?vue&type=template&id=42908a98&"
import script from "./SystemNotificationManagementSettings.vue?vue&type=script&lang=js&"
export * from "./SystemNotificationManagementSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports